const getFileNameTokens = (fileName) => {
  const fileNameWithoutExtension = fileName.replace(/\.[^.]+$/, '');

  return fileNameWithoutExtension.split(/[\s_.-]+/).filter((token) => {
    return Boolean(token);
  });
};

const hasMatchingIdentifier = (candidate, fileNameTokens) => {
  const aamcId = `${candidate.AAMCID || ''}`.trim();
  if (/^\d{8}$/.test(aamcId) && fileNameTokens.includes(aamcId)) {
    return true;
  }

  const sfMatchId = `${candidate.SFMatchID || ''}`.trim();
  if (sfMatchId.length >= 5 && fileNameTokens.includes(sfMatchId)) {
    return true;
  }

  return false;
};

const findMatchingCandidate = (fileNameTokens, candidates, matchedCandidateIds) => {
  const candidate = candidates.find((candidate) => {
    if (matchedCandidateIds.has(candidate.pk_Candidate)) {
      return false;
    }

    return hasMatchingIdentifier(candidate, fileNameTokens);
  });

  if (!candidate) {
    return false;
  }

  return candidate;
};

const matchFilesToCandidates = (files, candidates) => {
  const matchedCandidateIds = new Set();
  const matchedFiles = [];
  const unmatchedFiles = [];

  files.forEach((file, index) => {
    const fileNameTokens = getFileNameTokens(file.name);
    const candidate = findMatchingCandidate(fileNameTokens, candidates, matchedCandidateIds);

    if (!candidate) {
      unmatchedFiles.push({ file });
      return;
    }

    matchedCandidateIds.add(candidate.pk_Candidate);
    matchedFiles.push({
      file,
      FirstName: candidate.FirstName,
      LastName: candidate.LastName,
      pk_Candidate: candidate.pk_Candidate,
      uploadKey: `upload_${index}_${candidate.pk_Candidate}`,
    });
  });

  return { matchedFiles, unmatchedFiles };
};

export { getFileNameTokens, matchFilesToCandidates };
